import { store } from '@/app/store'
import axios from 'axios'

const baseURL = import.meta.env.VITE_ENV == 'PRODUCTION'
    ? import.meta.env.VITE_APP_BASE_URL_PROD + "/api"
    : import.meta.env.VITE_APP_BASE_URL_DEV + "/api"

export const axiosClient = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
})

axiosClient.interceptors.request.use(
    (config) => {
        const access_token = store.getState().adminAuth.access_token
        if (access_token) {
            config.headers.Authorization = `Bearer ${access_token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)